jQuery(document).ready(function () {
  if( window.localStorage.getItem('RE0420') != 1 ){
    setTimeout(function () {
      window.localStorage.setItem('RE0420', '1');
      jQuery('#popUpButton').click()
    }, 15000)
  }
})
